import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.scss";
import App from "./components/App/App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Dashboard from "components/Dashboard/Dashboard";
import "bootstrap-icons/font/bootstrap-icons.css";
const { REACT_APP_OAUTH_CLIENT_ID } = process.env;
ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={`${REACT_APP_OAUTH_CLIENT_ID}`}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
